<template>
    <p v-html="html"></p>
</template>

<script>
export default {
    props: {
        search: String,
        text: String,
        stringLength: {
            type: Number,
            default: 180,
        },
    },
    computed: {
        html() {
            let text = this.text || '';
            if (text.length > this.stringLength) {
                text = `${text.slice(0, this.stringLength)}...`;
            }
            return text.replace(
                new RegExp(this.search, 'i'), 
                (match) => `<span class="search_highlight">${match}</span>`
            );
        },
    },
};
</script>

<style lang="scss">
    .search_highlight {
        color: #4663AB;
    }
</style>